import type { FC, SVGProps } from 'react';

import {
  CalendarIcon,
  ChatIcon,
  DocumentIcon,
  HomeIcon,
  OrgIcon,
  QuestionIcon,
} from '../assets/icons/icons';

export interface NavNode {
  id: string;
  label: string;
  to?: string;
  exact?: boolean;
  icon?: FC<SVGProps<SVGSVGElement>>;
  children?: NavNode[];
  adminOnly?: boolean;
  userOnly?: boolean;
}

export const NAVIGATION: NavNode[] = [
  { id: 'home', label: 'Главная', to: '/', exact: true, icon: HomeIcon },
  { id: 'projects', label: 'Проекты', to: '/projects', icon: DocumentIcon },
  {
    id: 'admin',
    label: 'Админ. панель',
    icon: OrgIcon,
    adminOnly: true,
    children: [
      { id: 'access', label: 'Доступы', to: '/access' },
      {
        id: 'tech-support',
        label: 'Техническая поддержка',
        children: [
          { id: 'tech-support-requests', label: 'Запросы в техническую поддержку', to: '/support' },
          { id: 'tech-support-answers', label: 'Ответы на запросы пользователей', to: '/support-requests' },
          // { id: 'tech-support-limits', label: 'Информация по лимитам', to: '/requests' },
        ],
      },
      {
        id: 'handbook',
        label: 'Справочники',
        children: [
          { id: 'handbook-products', label: 'Товары и аналоги', to: '/handbook/products' },
          { id: 'handbook-sizes', label: 'Габариты', to: '/handbook/sizes/standard_size' },
        ],
      },
      { id: 'storage', label: 'Библиотека скриншотов', to: '/storage' },
      { id: 'global-blocks', label: 'Блокировки', to: '/global-blocks' },
      { id: 'admin-news', label: 'Новости', to: '/handbook/news' },
      { id: 'notifications', label: 'Уведомления', to: '/notifications' },
      { id: 'reports', label: 'Аналитика', to: '/reports' },
    ],
  },
  // { id: 'support', label: 'Обращения в техническую поддержку', to: '/support', icon: ChatIcon, userOnly: true },
  { id: 'support', label: 'Запросы в техническую поддержку', to: '/support', icon: ChatIcon, userOnly: true },
  { id: 'support-answers', label: 'Ответы на обращения', to: '/support-answers', icon: ChatIcon, userOnly: true },
  { id: 'news', label: 'Новости', to: '/news', icon: CalendarIcon, userOnly: true },
  { id: 'faq', label: 'Часто задаваемые вопросы', to: '/faq', icon: QuestionIcon },
];

export function filterNavigation(nodes: NavNode[], admin: boolean): NavNode[] {
  return nodes.reduce<NavNode[]>((acc, node) => {
    if (node.adminOnly && !admin) return acc;
    if (node.userOnly && admin) return acc;

    const children = node.children ? filterNavigation(node.children, admin) : undefined;
    if (node.children && !node.to && !children?.length) return acc;

    acc.push(children ? { ...node, children } : node);
    return acc;
  }, []);
}

export const ROUTES = {
  projects: '/projects',
  faq: '/faq',
  support: '/support',
  news: '/news',
} as const;